// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","802":"94726e6d"}[chunkId] || chunkId) + "-" + {"663":"e68cc1f7cfa4761c4f39","678":"9679cb4aa03db5b5e259","802":"ae7def931a73a3d8b978"}[chunkId] + ".js";
};